export const MarkerIcon = {
  green: {
    url: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
  },
  red: {
    url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
  },
  blue: {
    url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
  },
};
